import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RenewalCourse, RenewalCoursesState } from "./renewalCoursesSlice.types";

const initialState: RenewalCoursesState = {
	courses: [],
	totalCoursesToAdd: 0,
	currentCourseIndex: 0,
	isRenewalMode: false,
};

const renewalCoursesSlice = createSlice({
	name: "renewalCourses",
	initialState,
	reducers: {
		setRenewalCourses(state, action: PayloadAction<RenewalCourse[]>) {
			state.courses = action.payload;
		},
		addRenewalCourse(state, action: PayloadAction<RenewalCourse>) {
			state.courses.push(action.payload);
		},
		updateRenewalCourse(state, action: PayloadAction<{ id: string; updates: Partial<RenewalCourse> }>) {
			const index = state.courses.findIndex(course => course.id === action.payload.id);
			if (index !== -1) {
				state.courses[index] = { ...state.courses[index], ...action.payload.updates };
			}
		},
		setTotalCoursesToAdd(state, action: PayloadAction<number>) {
			state.totalCoursesToAdd = action.payload;
		},
		setCurrentCourseIndex(state, action: PayloadAction<number>) {
			state.currentCourseIndex = action.payload;
		},
		setIsRenewalMode(state, action: PayloadAction<boolean>) {
			state.isRenewalMode = action.payload;
		},
		incrementCourseIndex(state) {
			state.currentCourseIndex += 1;
		},
		resetRenewalCourses(state) {
			state.courses = [];
			state.totalCoursesToAdd = 0;
			state.currentCourseIndex = 0;
			state.isRenewalMode = false;
		},
	},
});

export const {
	setRenewalCourses,
	addRenewalCourse,
	updateRenewalCourse,
	setTotalCoursesToAdd,
	setCurrentCourseIndex,
	setIsRenewalMode,
	incrementCourseIndex,
	resetRenewalCourses,
} = renewalCoursesSlice.actions;

export default renewalCoursesSlice.reducer;
